import React from "react";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { WHY_US } from "../data/content";

const Icon = ({ name, ...props }) => {
  const C = Icons[name] || Icons.Check;
  return <C {...props} />;
};

export const WhyUs = () => {
  return (
    <section id="why-us" data-testid="why-us-section" className="py-24 bg-primary text-primary-foreground">
      <div className="px-6 md:px-12 lg:px-24">
        <div className="max-w-2xl mb-14">
          <span className="text-secondary font-semibold text-sm uppercase tracking-wider">Why work with us</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold tracking-tight">
            Honest, dependable, and done right
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {WHY_US.map((w, i) => (
            <motion.div
              key={w.title}
              data-testid={`why-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="border-t-2 border-secondary/40 pt-6"
            >
              <span className="inline-flex items-center justify-center w-14 h-14 rounded-sm bg-white/10 text-secondary">
                <Icon name={w.icon} className="w-7 h-7" />
              </span>
              <h3 className="mt-5 text-xl font-semibold tracking-tight">{w.title}</h3>
              <p className="mt-2 text-primary-foreground/75">{w.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
